import React from 'react';
import Counter from '../../../common/components/counter';

const CommentCount = (props) => <Counter i18nKey="comment-count.label" {...props} />;

export default CommentCount;
